

const initialState = {
    AllLoginTemplate:[],
    SingleLoginTemplate:{}
  
  }
  
  const LoginTemplateReducer = (state = initialState, action) => {
    const { type, payload } = action
    
    switch (type) {
      case 'SET_ALL_LOGIN_TEMPLATE': {
        return {
          ...state,
          AllLoginTemplate: payload,
        
        }
      }
  
      case 'SET_ALL_LOGIN_SINGLE_TEMPLATE': {
        return {
          ...state,
          SingleLoginTemplate: payload,
        
        }
      }
  
      default:
        return state
    }
  }
  
  export default LoginTemplateReducer